import { i18n } from '@/plugins/i18n'

export const marketingLevel = {
    level_1: 1,
    level_2: 2,
    level_3: 3,
}

export const marketingLevelStr = {
    level_1: i18n.t('marketing.filter.level_1'),
    level_2: i18n.t('marketing.filter.level_2'),
    level_3: i18n.t('marketing.filter.level_3'),
}